import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import EventBus from '../core/EventBus'
import { queryAll } from '../utils/dom'
import {EVENTS} from '../core/Events'

export default class Page extends Component {

    constructor(element, options) {
        super(element, options = {})
        this.otherVideosOnPage = []
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)

        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)
        EventBus.on(EVENTS.MODAL_CLOSE, this.handleModalClose)
    }

    handleClick = event => {
        if (event.defaultPrevented) {
            return
        }

        const target = event.target.closest('a')

        if (!target) {
            return
        }

        if (document.location.href.split('#')[0] !== target.href.split('#')[0]) {
            return
        }

        const id = target.href.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        event.preventDefault()

        let offset = (target.dataset.offset) ? target.dataset.offset : 0
        let mode = (target.dataset.mode) ? target.dataset.mode : 'force-center'

        scrollToElement(element, { offset, mode })
    }

    handleModalOpen = () => {
        this.pausePageVideos()
    }

    handleModalClose = () => {
        this.resumePageVideos()
    }

    pausePageVideos() {
        this.otherVideosOnPage = queryAll('video')
                                    .filter(videoEl => !videoEl.closest('.Modal'))
                                    .map(videoEl => ({ element: videoEl, wasPlaying: !videoEl.paused, hasAutoplayLoop: videoEl.hasAttribute('autoplay') && videoEl.hasAttribute('loop')}))

        this.otherVideosOnPage.forEach(video => {
            if (!video.element.paused) {
                video.element.pause()
            }
        })
    }

    resumePageVideos() {
        this.otherVideosOnPage.forEach(video => {
            if (video.hasAutoplayLoop || video.wasPlaying) video.element.play()
        })
    }

}